import styled from "styled-components";

export const HeaderMainDiv = styled.div`
  margin: 50px auto 10px;
  width: 100%;
  max-width: 860px;
  display: flex;
`;
export const Title = styled.p`
  font-size: 14px;
  font-weight: 600;
  color: #808080;
`;
